import React from 'react'
import { Link } from 'react-router-dom'

const Data = [
  {
    imgPath: '/images/features-1.png',
    subtitle: 'Features',
    title: 'Deep Whales AI Bot',
    description: `Deep Whales AI is revolutionising crypto trading by harnessing the
              power of blockchain analysis and AI. By tracking movements in over
              10,000 whale wallets and analysing market patterns, Deep Whales AI
              provides users direct alerts to their device with potential early
              opportunities. This unique utility brings early opportunities to
              both novice and seasoned traders to make informed decisions,
              maximise profits, and stay ahead in the fast paced crypto market. 
              Our aim is to give users the opportunity to enter into upcoming
              projects before they become mainstream.`,
  },
  {
    imgPath: '/images/features-2.png',
    subtitle: 'Features',
    title: 'Pulse Tracker',
    description: `PulseTracker is engineered to directly notify users about dormant crypto projects that exhibit sudden spikes in volume, signaling potential movements that might otherwise go unnoticed. Utilising AI algorithms and real time data, PulseTracker scrutinises the blockchain for noteworthy activity, providing traders with the opportunity to respond to these alerts. It allows users to manually input contract addresses they wish to monitor, including those of well-known projects recognised by the Ai using the blockchain. Over time, PulseTracker aggregates data from our users, compiling this information to highlight popular projects added by Deep Whales AI users and alert users.`,
  },
  {
    imgPath: '/images/features-1.png',
    subtitle: 'Features',
    title: 'AI Trader Bot',
    description: `The AI Trader Bot revolutionizes trading by allowing you to automatically replicate the strategies of identified top-performing traders. Including all the best features of your most popularly used buy and sell bot, creating a simple to use, recognisable and effective trading platform for all types of users. `,
  },
  {
    imgPath: '/images/features-3.png',
    subtitle: 'Features',
    title: 'Blue Whale Alert Bot',
    description: `The newest addition to our line up of our incredible toolkit, Blue Whale Alert Bot is one of the most sophisticated early buy alert systems that is available in the crypto space today.  Our new tiered system will give our users different options allowing them an opportunity to seamlessly integrate Deep Whales AI Bot with buys upon alert.  More information will be available on this soon.`,
  },
  {
    imgPath: '/images/features-4.png',
    subtitle: 'Features',
    title: 'SecureScan AI',
    description: `SecureScan AI is the pinnacle of security in the crypto world.
          Utilising AI algorithms, it monitors and scans contracts that are
          identified by Deep Whales to detect and alert of any unwanted
          malicious codes in contracts that you may wish to purchase. Creating
          an extra layer of security in Deep Whales AI bot, allowing you to make
          an informed decision before you decide to purchase. This will be made
          available initially through our Telegram Bot and then our Mobile App`,
  },
  {
    imgPath: '/images/features-5.png',
    subtitle: 'Features',
    title: 'Portfolio Manager',
    description: `The Portfolio Manager is a comprehensive utility for tracking and managing your entire crypto portfolio in one place. It offers performance analytics, asset distribution insights, and personalized recommendations for portfolio optimization based on asset performance. Integrating with the entire toolkit, this will become the central platform for users to interact with, providing all crypto updates, transactions, and overall portfolio management. Additionally, it includes options to buy and sell different cryptocurrencies across various chains, on and off-ramp fiat, and send and receive crypto.`,
  },
]

export default function Features() {
  return (
    <div
      class='w-full relative'
      id='about'
    >
      <section class='w-full md:max-w-[90%]  mx-auto py-10 relative flex flex-col justify-center items-center gap-4'>
        <div className='flex flex-col justify-center items-center gap-4 bg_elips'>
          <div className='box px-8 font-medium py-1.5 rounded-full text-[#DBA200] text-xl animate__slideInUp animate__animated wow'>
            Features
          </div>
          <h1 className='text-5xl animate__slideInUp animate__animated wow'>
            Our Features
          </h1>
          <p className='w-full max-w-[700px] text-center animate__slideInUp animate__animated wow px-5'>
            Deep Whales AI bot is a one-stop solution that consolidates all the
            essential tools into one platform. It offers arguably the most
            useful AI-driven toolkit, all in one place. No more scanning
            different bots or dApps; all alerts and buy/sell components are
            seamlessly integrated, making it the ultimate tool for streamlined
            trading.
          </p>
        </div>
        {Data.map((item) => (
          <div className='grid md:grid-cols-2 grid-cols-1 md:mt-20 mt-0 gap-10  sticky md:top-20 top-2 bg-black md:py-4 py-10 h-full px-5'>
            <div className='flex items-center justify-center mx-auto  '>
              <img
                src={item.imgPath}
                alt=''
                className='w-full md:max-w-[656px] max-w-[300px] animate__slideInUp animate__animated wow'
              />
            </div>
            <div className='flex flex-col justify-center md:items-start items-center md:space-y-5 space-y-3 '>
              <div className='box md:px-8 px-2 w-full max-w-40 text-center font-medium py-1.5 rounded-full text-[#DBA200] md:text-xl text-sm animate__slideInUp animate__animated wow '>
                {item.subtitle}
              </div>
              <h2 className='lg:text-5xl text-3xl animate__slideInUp animate__animated wow'>
                {item.title}
              </h2>
              <p className='md:text-start text-center md:text-base text-sm animate__slideInUp animate__animated wow'>
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}
